import { all, fork } from 'redux-saga/effects';
import ordersSaga from './orders/saga';
import userSaga from './sagas';

export default function* rootSaga() {
    yield all([
        fork(ordersSaga),
        fork(userSaga)
    ]);
}